import ReactDOM from "react-dom";
import { App } from "./App";

const elementToMount = document.getElementById("new-previewer");
if (!elementToMount) {
    $('#content > > .right')[0].remove()
    const newPreviewer = document.createElement('div');
    newPreviewer.setAttribute('id', 'new-previewer');
    newPreviewer.setAttribute('style', ' z-index: 10000000; position: absolute; right: 0; top: 0; height: 100%;');
    $('#content > .middle').append(newPreviewer);
    elementToMount = newPreviewer;
}

ReactDOM.render(<App />, elementToMount);